// extracted by mini-css-extract-plugin
export var progressContainer = "_dj-0";